'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/navigation';

import { T } from '@flipster/i18n';
import { useOverlay } from '@flipster/overlay';
import { Styles, css } from '@flipster/styled-system/css';
import { center, grid } from '@flipster/styled-system/patterns';

import { authBunja } from '../../shared/auth/state';
import { ContactChannelModal } from '../modal/contact-channel';
import { VipButton } from '../shared/vip-button';
import { sectionId } from './5-apply-form';

interface Props {
  css?: Styles;
}

export const CtaSection = ({ css: cssProps }: Props) => {
  const overlay = useOverlay();
  const router = useRouter();
  const { isLoggedInAtom } = useBunja(authBunja);
  const isLoggedIn = useAtomValue(isLoggedInAtom);

  const handleTryOutVip = () => {
    if (!isLoggedIn) return router.push('/login');
    const section = document.getElementById(sectionId);
    requestAnimationFrame(() => section?.scrollIntoView({ behavior: 'smooth' }));
  };

  return (
    <section
      className={css(
        center.raw({
          flexDir: 'column',
          gap: 48,
          py: { base: 40, tablet: 96 },
          px: 16,
        }),
        cssProps,
      )}
    >
      <h2 className={css({ textStyle: 'Display/XL', color: 'content.default.level-5', textAlign: 'center' })}>
        <T id='VIP.r260303.Join_flipster_vip_program' />
      </h2>
      <div
        className={grid({
          gridTemplateColumns: { base: '1fr', tablet: '1fr 1fr' },
          gap: 10,
          justifyContent: 'center',
          tabletDown: { w: '100%' },
        })}
      >
        <VipButton
          hierarchy='primary'
          label={<T id='Vip.r260121.Chat_with_VIP_team_button' />}
          onClick={() => overlay.open(() => <ContactChannelModal />)}
        />
        <VipButton hierarchy='secondary' label={<T id='Vip.r260121.Try_out_VIP_button' />} onClick={handleTryOutVip} />
      </div>
    </section>
  );
};
